import type { RouteLocationRaw, Router } from 'vue-router';

/**
 * Opens a route in a new browser tab and switches to it. Call from a
 * keydown/click handler so the browser counts it as a user gesture and doesn't
 * block the popup; focus() is explicit because a scripted open lands in the
 * background.
 */
export function openRouteInNewTab(router: Router, to: RouteLocationRaw): void {
  window.open(router.resolve(to).href, '_blank')?.focus();
}
